import { Button, Flex, Typography, emailRegex } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

interface ForgotPasswordScreenProps {
  error: string | null;
  forgotPasswordScreen: 'form' | 'success';
  onBack: () => void;
  onSubmit: (data: { email: string }) => void;
}

export const ForgotPasswordScreen = ({
  error,
  forgotPasswordScreen,
  onBack,
  onSubmit,
}: ForgotPasswordScreenProps) => {
  return (
    <Flex flexDirection="column" p={24}>
      {forgotPasswordScreen === 'form' ? (
        <>
          <Form name="forgot-password" onSubmit={onSubmit}>
            <Typography variant="h2-semibold" mb={16}>
              Reset your password
            </Typography>
            <Typography mb={16}>
              Enter your email address below and we’ll send you an email with
              instructions for creating a new password.
            </Typography>
            <Form.TextField
              type="email"
              autocomplete="off"
              label={
                <Typography variant="body-semibold" mb={-8} mr="auto">
                  Email address
                </Typography>
              }
              name="email"
              required
              errorMessage="Please enter a valid email address."
              errorOnBlur
              pattern={emailRegex}
              disableMobileInputStyling
              mb={16}
              borderRadius="xs"
            />

            {error && (
              <Typography color="error" mt={-12} mb={12}>
                {typeof error === 'string'
                  ? error
                  : 'There was an error trying to initiate the reset.'}
              </Typography>
            )}

            <Form.SubmitButton
              full
              size="small"
              variant="primary"
              label="Submit"
              mb={16}
            />
          </Form>
          <Button
            full
            size="small"
            label="Back"
            variant="tertiary"
            onClick={onBack}
            type="button"
          />
        </>
      ) : (
        <>
          <Typography variant="h2-semibold" mb={16}>
            Check your email
          </Typography>
          <Typography mb={16}>
            A link to reset your password was sent to your email address. Check
            your email and reset.
          </Typography>
          <Button
            full
            size="small"
            label="Go back and sign in"
            onClick={onBack}
          />
        </>
      )}
    </Flex>
  );
};
